const emailRegex = /\S+@\S+\.\S+/; // Regex for email validation
const passwordRegex =
	/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/; // Regex for strong password validation
const phoneNumberRegex = /^[0-9]{10}$/; // Example regex for 10-digit phone numbers

export { emailRegex, passwordRegex, phoneNumberRegex };
